import { render, staticRenderFns } from "./manage.vue?vue&type=template&id=1a4b9f92&scoped=true&"
import script from "./manage.vue?vue&type=script&lang=js&"
export * from "./manage.vue?vue&type=script&lang=js&"
import style0 from "./manage.vue?vue&type=style&index=0&id=1a4b9f92&prod&lang=less&scoped=true&"
import style1 from "./manage.vue?vue&type=style&index=1&id=1a4b9f92&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4b9f92",
  null
  
)

export default component.exports